<template>
    <div v-frag>
        <CardIeaAppMain colorCard="#A7BA38" title="">
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)">
                    <v-icon dark>
                        mdi-keyboard-backspace
                    </v-icon>
                </v-btn>
                <br /><br />
                 <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text d-flex align-center flex-wrap">
                    Mis Materias
                    <v-switch
                        v-model="switchLegacyVersion"
                        label="Volver a versión anterior"
                        @change="goToLegacyVersion"
                        hide-details
                        class="ml-4 mt-0 pt-0"
                    ></v-switch>
                </div>
                <v-row class="pa-2">
                    <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                        <v-row>
                            <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6" v-for="(mt, index) in materias"
                                :key="index">
                                <v-card class="progress-card" elevation="2" rounded="lg" @click="irDetalleMateria(mt, index)">
                                    <v-card-text>
                                        <v-row align="start" class="mb-3">
                                            <v-col cols="auto">
                                                <v-avatar size="56" :color="mt.color" rounded="lg">
                                                    <v-icon color="white" size="32">mdi-clipboard-text</v-icon>
                                                </v-avatar>
                                            </v-col>
                                            <v-col>
                                                <h3 class="text-h6 font-weight-bold mb-0" style="line-height: 1.2;">
                                                    {{ mt.materiaName }}
                                                </h3>
                                            </v-col>
                                        </v-row>

                                        <div class="d-flex align-center justify-space-between mb-1">
                                            <div class="d-flex align-center">
                                                <span class="text-caption font-weight-bold grey--text text--darken-3">Progreso de Contenido</span>
                                            </div>
                                            
                                            <div v-if="mt.code">
                                                <v-btn
                                                    color="#FF4B2B"
                                                    dark
                                                    x-small
                                                    rounded
                                                    elevation="0"
                                                    class="white--text px-2 btn-en-vivo pulse-animation"
                                                    :href="linkMeet(mt.code)"
                                                    target="_blank"
                                                    @click.stop="logPerseverancia()"
                                                >
                                                    <v-icon left size="12" class="mr-1">mdi-video</v-icon>
                                                    EN VIVO
                                                </v-btn>
                                            </div>
                                        </div>

                                        <v-progress-linear 
                                            :value="mt.porcentaje" 
                                            :color="mt.color"
                                            background-color="grey lighten-3" 
                                            height="6" 
                                            rounded
                                            class="mt-1"
                                        ></v-progress-linear>
                                        <div class="text-right text-caption mt-1 font-weight-bold" :style="{ color: mt.color }">
                                            {{ mt.porcentaje }}%
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>

                    </v-col>
                    <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                        <v-card class="rounded-lg mb-4" elevation="2">
                            <v-card-title class="calendario-header py-2">
                                <v-icon color="grey darken-2" class="mr-2">mdi-calendar</v-icon>
                                Calendario de Exámenes
                            </v-card-title>
                            <v-card-text class="pa-2">
                                <div class="d-flex align-center justify-space-between px-2 mb-2">
                                    <v-btn icon small @click="mesAnterior">
                                        <v-icon>mdi-chevron-left</v-icon>
                                    </v-btn>
                                    <span class="text-h6 font-weight-medium text-capitalize">
                                        {{ nombreMes }} {{ anioActual }}
                                    </span>
                                    <v-btn icon small @click="mesSiguiente">
                                        <v-icon>mdi-chevron-right</v-icon>
                                    </v-btn>
                                </div>

                                <v-simple-table dense class="calendario-table">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th v-for="dia in diasSemana" :key="dia" class="text-center calendario-th">
                                                    {{ dia }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(semana, sIndex) in semanasDelMes" :key="sIndex">
                                                <td
                                                    v-for="(dia, dIndex) in semana"
                                                    :key="dIndex"
                                                    class="text-center calendario-td"
                                                    :class="{
                                                        'dia-hoy': dia && esHoy(dia),
                                                        'dia-domingo': dia && esDomingo(sIndex, dIndex),
                                                        'dia-evento': dia && tieneEvento(dia)
                                                    }"
                                                >
                                                    <v-tooltip bottom v-if="dia && tieneEvento(dia)">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <span v-bind="attrs" v-on="on" class="dia-con-evento">{{ dia }}</span>
                                                        </template>
                                                        <div v-for="(ev, i) in getEventosDia(dia)" :key="i">
                                                            <strong>{{ ev.titulo }}</strong><br />
                                                            {{ formatFecha(ev.inicio) }} - {{ formatFecha(ev.fin) }}
                                                        </div>
                                                    </v-tooltip>
                                                    <span v-else-if="dia">{{ dia }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>

                                <div class="d-flex flex-wrap align-center px-2 mt-2">
                                    <v-chip x-small dark class="mr-2 mb-1" color="#8E24AA">Próximo Examen</v-chip>
                                </div>

                                <div v-if="proximosExamenes.length > 0" class="mt-3 px-2">
                                    <div class="text-subtitle-2 font-weight-bold mb-2">Próximos Exámenes</div>
                                    <div
                                        v-for="(evento, index) in proximosExamenes"
                                        :key="index"
                                        class="d-flex align-center mb-2 pa-2 rounded"
                                        :style="{ borderLeft: '4px solid ' + (evento.color || '#8E24AA'), backgroundColor: '#f9f9f9' }"
                                    >
                                        <div class="flex-grow-1">
                                            <div class="text-body-2 font-weight-medium mb-1">{{ evento.titulo }}</div>
                                            <div class="text-caption grey--text">
                                                {{ formatFecha(evento.inicio) }} - {{ formatFecha(evento.fin) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <v-alert v-else-if="show" prominent type="info" class="mt-3">
                                    No hay próximos exámenes
                                </v-alert>
                            </v-card-text>
                        </v-card>
                        <br>
                        <div class="
            text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4
            primary--text">
                            Cursos Gratis
                        </div>
                        <v-row>
                            <v-col cols="12" sm="12" xs="12" md="6" lg="4" xl="4" v-for="cg in cursosGratis"
                                :key="cg.IDStB">
                                <v-card class="curso-card" elevation="1" @click="abrirContenidoGratis(cg)">
                                    <!-- Ícono -->
                                    <div class="curso-icon-wrap">
                                        <v-icon color="info" size="28">
                                            mdi-clipboard-text
                                        </v-icon>
                                    </div>

                                    <!-- Nombre -->
                                    <span class="curso-nombre">{{ cg.nombre }}</span>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </CardIeaAppMain>
    </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
    name: "MisMaterias",
    data() {
        return {
            materias: [],
            cursosGratis: [],
            show: false,
            currentMonth: "",
            dialog: false,
            evento_id: "",
            evento: {},
            eventos: [],
            mesActual: new Date().getMonth(),
            anioActual: new Date().getFullYear(),
            diasSemana: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
            eventosCalendario: [],
            switchLegacyVersion: true
        }
    },
    computed: {
        nombreMes() {
            const meses = [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre"
            ];
            return meses[this.mesActual];
        },
        semanasDelMes() {
            const primerDia = new Date(this.anioActual, this.mesActual, 1);
            const ultimoDia = new Date(this.anioActual, this.mesActual + 1, 0);
            const diasEnMes = ultimoDia.getDate();
            const diaInicio = primerDia.getDay();

            const semanas = [];
            let semanaActual = new Array(7).fill(null);

            for (let dia = 1; dia <= diasEnMes; dia++) {
                const posicion = (diaInicio + dia - 1) % 7;
                if (posicion === 0 && dia > 1) {
                    semanas.push(semanaActual);
                    semanaActual = new Array(7).fill(null);
                }
                semanaActual[posicion] = dia;
            }
            semanas.push(semanaActual);
            return semanas;
        },
        proximosExamenes() {
            const hoy = new Date();
            hoy.setHours(0, 0, 0, 0);
            return this.eventosCalendario
                .filter((ev) => new Date(ev.fin) >= hoy)
                .sort((a, b) => new Date(a.inicio) - new Date(b.inicio))
                .slice(0, 5);
        }
    },
    components: {
        CardIeaAppMain
    },
    methods: {
        esHoy(dia) {
            const hoy = new Date();
            return (
                dia === hoy.getDate() &&
                this.mesActual === hoy.getMonth() &&
                this.anioActual === hoy.getFullYear()
            );
        },
        esDomingo(semanaIndex, diaIndex) {
            return diaIndex === 0;
        },
        tieneEvento(dia) {
            return this.eventosCalendario.some((e) => {
                const inicio = new Date(e.inicio);
                const fin = new Date(e.fin);
                const fecha = new Date(this.anioActual, this.mesActual, dia);
                inicio.setHours(0, 0, 0, 0);
                fin.setHours(0, 0, 0, 0);
                fecha.setHours(0, 0, 0, 0);
                return fecha >= inicio && fecha <= fin;
            });
        },
        getEventosDia(dia) {
            return this.eventosCalendario.filter((e) => {
                const inicio = new Date(e.inicio);
                const fin = new Date(e.fin);
                const fecha = new Date(this.anioActual, this.mesActual, dia);
                inicio.setHours(0, 0, 0, 0);
                fin.setHours(0, 0, 0, 0);
                fecha.setHours(0, 0, 0, 0);
                return fecha >= inicio && fecha <= fin;
            });
        },
        formatFecha(fechaStr) {
            if (!fechaStr) return "";
            return String(fechaStr).split(" ")[0].split("-").reverse().join("/");
        },
        mesAnterior() {
            if (this.mesActual === 0) {
                this.mesActual = 11;
                this.anioActual--;
            } else {
                this.mesActual--;
            }
        },
        mesSiguiente() {
            if (this.mesActual === 11) {
                this.mesActual = 0;
                this.anioActual++;
            } else {
                this.mesActual++;
            }
        },
        abrirContenido(ruta) {
            window.open(ruta, '_blank')
        },
        goToLegacyVersion() {
            this.$router.push({ name: "MisMateriasNew" });
        },
        linkMeet(code) {
          return "https://meet.google.com/" + code;
        },
        async logPerseverancia() {
          await this.$API
            .get(
              {
                url: "alumno/setperseverancia"
              },
              false
            )
            .then(res => {
              if (!res.tieneBadge1) {
                if (res.registraBadge1) {
                  this.$store.commit("tieneBadge1", res.registraBadge1);
                }
              }

              if (!res.tieneBadge2) {
                if (res.registraBadge2) {
                  this.$store.commit("tieneBadge2", res.registraBadge2);
                }
              }

              if (!res.tieneBadge3) {
                if (res.registraBadge3) {
                  this.$store.commit("tieneBadge3", res.registraBadge3);
                }
              }
              this.$store.commit("porcentaje1", res.porcentaje1);
              this.$store.commit("porcentaje2", res.porcentaje2);
              this.$store.commit("porcentaje3", res.porcentaje3);
            });
        },
        irDetalleMateria(mt) {
            this.$router.push({
                name: "MisMateriaDetalle",
                params: { materiaId: mt.materia_id },
                query: { 
                    nombre: mt.materiaName,
                    color: mt.color,
                    progreso: mt.porcentaje
                }
            });
        },
        abrirContenidoGratis(cGratis){
            window.open("/materia/clases/"+cGratis.uuid+"/"+cGratis.materia_id+"/"+cGratis.IDStB, '_blank')

        },
        getMaterias() {
            if (
                this.$store.getters.user.borrado == 1 ||
                this.$store.getters.user.alumno_mora == true ||
                this.$store.getters.user.excedente
            ) {
                this.$router.push({
                    name: "Home"
                });
            }
            this.$API
                .get({
                    url: "materias-new",
                    data: {}
                })
                .then(res => {
                    console.log(res);
                    this.materias = res;
                });
        },
        obtenerCursosGratis() {
            this.$API
                .get({
                    url: "materias-gratis",
                    data: {}
                })
                .then(res => {
                    console.log(res);
                    this.cursosGratis = res;
                });
        },
        abrirEnlace(enlace) {
            window.open(enlace, '_blank')
        },
        handleEventClick(clickInfo) {
            let datos = clickInfo.event.extendedProps;

            if (datos.evento_id) {
                this.evento_id = datos.evento_id;

                let url = `calendario/` + this.evento_id;

                this.$API
                    .get({
                        url
                    })
                    .then(res => {
                        this.evento = res;
                        this.dialog = true;
                    });
            }
        },
        async obtenerProximosEventos() {
            try {
                const res = await this.$API.get({
                    url: "examen/proximos-materias-asignadas",
                    data: {}
                });

                const hoy = new Date();
                hoy.setHours(0, 0, 0, 0);

                const eventosRaw = Array.isArray(res?.eventos) ? res.eventos : [];
                const eventos = eventosRaw
                    .map((ev, idx) => {
                        const inicioRaw = ev?.inicio || ev?.fecha_inicio || ev?.start || null;
                        const finRaw = ev?.fin || ev?.fecha_fin || ev?.fecha_final || ev?.end || inicioRaw;
                        if (!inicioRaw || !finRaw) return null;

                        const inicio = String(inicioRaw).split(" ")[0];
                        const fin = String(finRaw).split(" ")[0];

                        const fechaFinObj = new Date(`${fin}T23:59:59`);
                        if (Number.isNaN(fechaFinObj.getTime()) || fechaFinObj < hoy) return null;

                        const tituloBase = ev?.titulo || ev?.title || "Test";
                        const materia = ev?.materia ? ` - ${ev.materia}` : "";
                        const tipoExamen = ev?.tipo_examen ? ` (${ev.tipo_examen})` : "";

                        return {
                            id: ev?.test_detail_id || ev?.id || `test-${idx}`,
                            titulo: `${tituloBase}${tipoExamen}${materia}`,
                            inicio,
                            fin,
                            color: ev?.color || "#8E24AA"
                        };
                    })
                    .filter(Boolean);

                const uniqueMap = new Map();
                eventos.forEach((ev) => {
                    const key = `${ev.titulo}|${ev.inicio}|${ev.fin}`;
                    if (!uniqueMap.has(key)) uniqueMap.set(key, ev);
                });

                this.eventosCalendario = Array.from(uniqueMap.values())
                    .sort((a, b) => new Date(a.inicio) - new Date(b.inicio));
            } catch (e) {
                this.eventosCalendario = [];
            } finally {
                this.show = true;
            }
        }
    },
    mounted() {
        this.getMaterias();
        this.obtenerCursosGratis()
        this.obtenerProximosEventos()
    }
}
</script>
<style scoped>
.progress-card {
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    border: 1px solid #f0f0f0 !important;
}

.progress-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 15px rgba(0,0,0,0.08) !important;
}

.btn-en-vivo {
    font-size: 9px !important;
    height: 20px !important;
    font-weight: bold;
    letter-spacing: 0.5px;
}

@keyframes pulse-red {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 75, 43, 0.4);
    }
    70% {
        box-shadow: 0 0 0 8px rgba(255, 75, 43, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(255, 75, 43, 0);
    }
}

.pulse-animation {
    animation: pulse-red 2s infinite;
}
.calendario-header {
    background-color: #f5f5f5;
    font-size: 1rem;
    font-weight: 600;
    border-bottom: 2px solid #e0e0e0;
}

.calendario-table {
    width: 100%;
}

.calendario-th {
    background-color: #5b9bd5 !important;
    color: white !important;
    font-weight: 600 !important;
    padding: 8px 4px !important;
    font-size: 0.85rem !important;
}

.calendario-td {
    padding: 10px 4px !important;
    font-size: 0.9rem;
    border-bottom: 1px solid #e0e0e0;
}

.dia-hoy {
    background-color: #f57c00 !important;
    color: white !important;
    font-weight: bold;
    border-radius: 4px;
}

.dia-domingo {
    color: #e65100 !important;
    font-weight: 600;
}

.dia-evento {
    background-color: #f3e5f5 !important;
    font-weight: 600;
}

.curso-card {
    flex: 0 0 130px;
    border-radius: 10px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 16px 10px 12px !important;
    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    border: 1px solid #e8e8e8;
}

.curso-card:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, .15) !important;
    transform: translateY(-2px);
}

.curso-icon-wrap {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
}

/* ── Nombre del curso ── */
.curso-nombre {
    font-size: 12px;
    font-weight: 500;
    color: #333;
    line-height: 1.4;
}

/* :deep(.fc .fc-daygrid-day-top) {
  padding: 2px 4px;
}

:deep(.fc .fc-daygrid-day-number) {
  font-size: 11px;
  padding: 0;
} */
</style>